<template>
    <div>
        <div class="Search">
            <div>
                <div @click="$router.push('/search')">
                    <i class="el-icon-search SearchIcon"></i>
                </div>
            </div>
        </div>
        <div class="Bilibili">
    <div>
        <el-popover
                placement="left"
                title="卑微UP主，在线求关注"
                width="210"
                trigger="hover"
                content="">
            <div style="width:200px;height:180px;">
                <img
                        style="width:180px;height:180px;object-fit: cover;"
                        src="../assets/DashenAE.png"
                        alt />
            </div>
            <el-button slot="reference" >
                <i class="el-icon-c-scale-to-original BilibiliIcon"></i>
            </el-button>
        </el-popover>
    </div>
    </div>
        <div class="WeiXin">
            <div>
                <el-popover
                        placement="left"
                        title="扫描二维码，关注公众号"
                        width="210"
                        trigger="hover"
                        content="">
                    <div style="width:200px;height:180px;">
                        <img
                                style="width:180px;height:180px;object-fit: cover;"
                                src="../assets/公众号01.jpg"
                                alt />
                    </div>
                    <el-button slot="reference" >
                        <i class="el-icon-chat-dot-round WeiXinIcon"></i>
                    </el-button>
                </el-popover>
            </div>
        </div>
        <div class="KeFu">
            <div>
                <el-popover
                        placement="left"
                        title="客服QQ：544038467"
                        width="210"
                        trigger="hover"
                        content="">
                    <div style="width:200px;height:180px;">
                        <img
                                style="width:180px;height:180px;object-fit: cover;"
                                src="../assets/544038467.png"
                                alt />
                    </div>
                    <el-button slot="reference" >
                        <i class="el-icon-headset KeFuIcon"></i>
                    </el-button>
                </el-popover>
            </div>
        </div>
        <div class="Collection">
            <div>
                <el-popover
                        placement="left"
                        title="支付宝扫码，打赏站长！"
                        width="210"
                        trigger="hover"
                        content="">
                    <div style="width:200px;height:180px;">
                        <img
                                style="width:180px;height:180px;object-fit: cover;"
                                src="../assets/支付宝.png"
                                alt />
                    </div>
                    <el-button slot="reference" >
                        <i class="el-icon-star-off CollectionIcon"></i>
                    </el-button>
                </el-popover>
            </div>
        </div>
        <div class="Mobile">
            <div>
                <el-popover
                        placement="left"
                        title="点击可切换手机端界面！"
                        width="150"
                        trigger="hover"
                        content="">
                    <el-button slot="reference" >
                        <i class="el-icon-mobile-phone MobileIcon" @click="$router.push('/mobile')"></i>
                    </el-button>
                </el-popover>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped>
    /*Search*/
    .Search {
        position: fixed;
        right: 40px;
        bottom: 370px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #fff;
        padding: 10px;
        cursor: pointer;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
    }
    .Search:hover .SearchIcon {
        color: rgba(51, 153, 255, 1);
    }
    .SearchIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
    /*Bilibili*/
    .Bilibili {
        position: fixed;
        right: 45px;
        bottom: 325px;
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: #fff;
        padding: 0;
        cursor: pointer;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.12);
    }
    .Bilibili:hover .BilibiliIcon {
        color: rgba(51, 153, 255, 1);
    }
    .BilibiliIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
    /*微信*/
    .WeiXin {
        position: fixed;
        right: 45px;
        bottom: 290px;
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: #fff;
        padding: 0;
        cursor: pointer;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.12);
    }
    .WeiXin:hover .WeiXinIcon {
        color: rgba(51, 153, 255, 1);
    }
    .WeiXinIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
    /*客服*/
    .KeFu {
        position: fixed;
        right: 45px;
        bottom: 255px;
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: #fff;
        padding: 0;
        cursor: pointer;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.12);
    }
    .KeFu:hover .KeFuIcon {
        color: rgba(51, 153, 255, 1);
    }
    .KeFuIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
    /*手机端*/
    .Mobile {
        position: fixed;
        right: 45px;
        bottom: 195px;
        width: 40px;
        height: 30px;
        border-radius: 0;
        background: #fff;
        padding: 0;
        cursor: pointer;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.12);
    }
    .Mobile:hover .MobileIcon {
        color: rgba(51, 153, 255, 1);
    }
    .MobileIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
    /*收藏*/
    .Collection {
        position: fixed;
        right: 45px;
        bottom: 220px;
        width: 40px;
        height: 40px;
        border-radius: 0;
        background: #fff;
        padding: 0;
        cursor: pointer;
        box-shadow: 0 0 0 rgba(0, 0, 0, 0.12);
    }
    .Collection:hover .CollectionIcon {
        color: rgba(51, 153, 255, 1);
    }
    .CollectionIcon {
        font-size: 20px;
        color: rgba(51, 153, 255, 0.8);
    }
</style>